import { useEffect } from "react";

import { useJobsPendingappprovalViewModel } from "../viewmodel/pendingApproval.viewmodel";
import JobPendingApprovalCard from "../Components/PendingApprovalCard";
import Toast from "../../../../components/Toast";
import RejectCommentModal from "../Components/RejectCommentModal";
import TablePagination from "../Components/TablePagination";

export const PendingApprovalsPage = () => {
  const {
    state,
    dispatch,
    loadPendingApprovals,
    handleJobApproval,
    hideToastMessage,
    rejectModal,
    setRejectModal,
    openRejectModal,
    closeRejectModal,
    currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
  } = useJobsPendingappprovalViewModel();

  useEffect(() => {
    loadPendingApprovals(currentPage, rowsPerPage);
  }, [currentPage, loadPendingApprovals, rowsPerPage]);

  const handleAction = (jobId: string, action: "approve" | "reject") => {
    if (action === "reject") {
      openRejectModal(jobId);
    } else {
      handleJobApproval(jobId, action);
    }
  };

  return (
    <div>
      {state.count === 0 ? (
        <div className="px-6 py-12 text-center">
          <svg
            className="mx-auto h-12 w-12 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6a2 2 0 01-2 2H8a2 2 0 01-2-2V8a2 2 0 012-2h8z"
            />
          </svg>
          <h3 className="mt-2 text-sm font-medium text-gray-900">
            No Pending Approvals found
          </h3>
        </div>
      ) : (
        <div className="space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
            {state.pendingApprovals.map((pending) => (
              <JobPendingApprovalCard
                key={pending?.job_id}
                jobPending={pending}
                onAction={handleAction}
                openMenuJobId={state.openMenuJobId}
                dispatch={dispatch}
              />
            ))}
          </div>

          {state.count > rowsPerPage && (
            <TablePagination
              currentPage={currentPage}
              totalCount={state.count}
              rowsPerPage={rowsPerPage}
              onPageChange={(page) => {
                handlePageChange(page);
              }}
              onRowsPerPageChange={(rows) => {
                handleRowsPerPageChange(rows);
                loadPendingApprovals(1, rows);
              }}
              isGrid={true}
            />
          )}
        </div>
      )}

      {rejectModal && (
        <RejectCommentModal
          comment={rejectModal.comment}
          onChange={(value) => setRejectModal({ ...rejectModal, comment: value })}
          onSubmit={() => {
            handleJobApproval(rejectModal.jobId, "reject", rejectModal.comment);
            closeRejectModal();
          }}
          onClose={closeRejectModal}
        />
      )}

      <Toast
        message={state.toast.message}
        type={state.toast.type}
        isVisible={state.toast.isVisible}
        onClose={hideToastMessage}
      />
    </div>
  );
};
